import { LogicNodeDefinition } from '../LogicNodeDefinition';

export const NotNode: LogicNodeDefinition = {
  type: 'NOT',
  createDefaultState: () => null,
  process: (input) => !input,
};
